import React from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';
import Layout from '../components/layout';
import IntroVideo from '../components/IntroVideo';

import { Container } from '@material-ui/core';

const IndexPage = () => {
  return (
    <Layout>
      <ParallaxProvider>
        <Container maxWidth={false} disableGutters={true}>
          <IntroVideo />
        </Container>
      </ParallaxProvider>
    </Layout>
  );
};

export default IndexPage;
